import { GroceryUnit, NutritionUnit } from '../enums';
import { z } from 'zod';

import { CoverSourceName } from './asset-source';
import { Translation } from './translation';

export const GroceryUnitEnum = z.enum([
  GroceryUnit.G,
  GroceryUnit.MG,
  GroceryUnit.ML,
  GroceryUnit.TSP,
  GroceryUnit.PCS,
]);

export const NutritionUnitEnum = z.enum([
  NutritionUnit.G,
  NutritionUnit.MG,
  NutritionUnit.KCAL,
]);

export const NutritionValueDto = z.object({
  name: z.string(),
  // 0 is a real value (0 g of salt) — matches the UI form schema.
  value: z.number().nonnegative('VALIDATION__NonNegative'),
  unit: NutritionUnitEnum,
});

export const CreateGroceryDto = z.object({
  coverSource: CoverSourceName.optional(),
  coverType: z.string().optional(),
  tags: z.array(z.string()).optional(),
  translations: z.array(Translation),
  nutritionValues: z.array(NutritionValueDto).optional(),
  configuration: z
    .object({
      isOrg: z.boolean().optional(),
    })
    .optional(),
});

export type ApiCreateGroceryDto = z.infer<typeof CreateGroceryDto>;

export const UpdateGroceryDto = z
  .object({
    coverSource: CoverSourceName.optional().nullable(),
    coverType: z.string().optional(),
    tags: z.array(z.string()).optional(),
    translations: z.array(Translation).optional(),
    nutritionValues: z.array(NutritionValueDto).optional(),
    configuration: z
      .object({
        isOrg: z.boolean().optional(),
      })
      .optional(),
  })
  .strict();

export type ApiUpdateGroceryDto = z.infer<typeof UpdateGroceryDto>;
